<div class="container">
    <!-- Bouton de fermeture de la popup -->
    <mat-icon class="closeBtn" (click)="close(false)">close</mat-icon>
    <!-- {{videoUrl}} -->
    <div class="videoContainer">
        <mat-spinner id="videoSpinner" [diameter]="50"></mat-spinner>
        <video *ngIf="!templateDescriptionPictureUrl" autoplay="autoplay" [controls]="videoUrl != null" muted="{{muted}}" loop class="media" src="{{videoUrl}}"  id="mediaVideo" #video>
        </video>
        <br>
        <img *ngIf="templateDescriptionPictureUrl" id="mediaImage"  class="media" [src]="templateDescriptionPictureUrl" alt="Template Description">
    </div>
    <div class="detailContainer">
        <p class="spotName">{{template.name}}</p>
        <p class="spotDuration">{{template.duration}} sec</p>
        <div class="stepperDescriptionContainer">
            <h4>Avec cette animation vous modifierez les éléments suivants</h4>
           
            <div class="propertyList">
                <div
                    class="informationItem"
                    *ngFor="let templateValue of xmlTemplateProperty"
                >
                    <span class="numberIndicator"><span>{{templateValue.step}}</span></span>
                    <div>
                        <p>
                            {{templateValue.description}}
                            
                        </p>
                        <div class="spanContainer">
                            <span *ngIf="templateValue.propertyType == 0 || templateValue.propertyType == 2">Texte</span>
                            <span *ngIf=" templateValue.propertyType == 1 || templateValue.propertyType == 2 ">
                                Image 
                                <span class="imageSize" *ngIf="templateValue.propertyType != 0 && templateValue.pictureHeight != null 
                                && templateValue.pictureHeight != 0 && templateValue.pictureWidth != null && templateValue.pictureWidth != 0" >
                                   ( {{templateValue.pictureWidth}}px * {{templateValue.pictureHeight}}px )
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>

        <button *ngIf="!template.notCompatibleWithThisSpot && seeNext" class="selectButton"
                    (click)="close(true)"
                    mat-stroked-button
                    color="primary"
                >
            Sélectionner
        </button>
    </div>
    
</div>